import { createTheme } from "@mui/material/styles";
import { colors } from "./color/colors";
import { fonts } from "./fonts/fonts";

const theme = createTheme({
  typography: {
    fontFamily: `${fonts.manrope}, sans-serif`,
    button: {
      textTransform: "none",
    },
  },
  palette: {
    primary: {
      main: colors.primaryOrange,
    },
    secondary: {
      main: colors.SecondaryMidnightBlue,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          padding:
            "env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)",
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingBottom: "16px",
        },
      },
    },
  },
});

export default theme;
